import { gql } from '@apollo/client';
import { ErrorMessageInfo, PatientInfoShared } from '@retainerclub/shared-api';

export default gql`
  mutation actionTogglePatientHasPlan($input: TogglePatientHasPlanActionInput!) {
    actionTogglePatientHasPlan(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      patient {
        ...PatientInfoShared
      }
    }
  }
  ${ErrorMessageInfo}
  ${PatientInfoShared}
`;
